<script setup>
  import { onMounted } from "vue";
  import { storeToRefs } from "pinia";
  import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
  import { Badge } from "@/components/ui/badge";
  import { EmptyState } from "@/components/episto-ui/empty-state";
  import ActionEditForm from "@/components/MCampaign/Actions/ActionEditForm.vue";
  import { useMCampaignStore } from "@stores/mCampaign";
  import { useCCampaignsStore } from "@stores/cCampaigns";
  import { useCAdsetsStore } from "@stores/cAdsets";
  import { useCampaignTargetsStore } from "@stores/campaignTargets";
  import { useMCampaignQuotasStore } from "@stores/mCampaignQuotas";
  import { useMCampaignActionsStore } from "@stores/mCampaignActions";

  const { currentMCampaign } = storeToRefs(useMCampaignStore());
  const { fetchCCampaigns } = useCCampaignsStore();
  const { fetchCAdsets } = useCAdsetsStore();
  const { fetchTargets } = useCampaignTargetsStore();
  const { fetchMCampaignQuota } = useMCampaignQuotasStore();
  const { noActionExist, currentAction, currentActionIndex } = storeToRefs(useMCampaignActionsStore());

  onMounted(async () => {
    await Promise.all([
      fetchCCampaigns(currentMCampaign.value.token),
      fetchCAdsets(currentMCampaign.value.token),
      fetchTargets(currentMCampaign.value.token),
      fetchMCampaignQuota(currentMCampaign.value.survey_token),
    ]);
  });
</script>

<template>
  <Card class="p-6 max-h-[calc(100vh-60px-40px)] flex flex-col">
    <CardHeader
      v-if="!noActionExist"
      class="pb-6">
      <div class="flex items-center justify-between gap-3">
        <CardTitle class="heading-page truncate">
          {{ currentAction.name?.trim() || `Action #${currentActionIndex + 1}` }}
        </CardTitle>
        <Badge :variant="currentAction.active === false ? 'secondary' : 'default'">
          {{ currentAction.active === false ? "Inactive" : "Active" }}
        </Badge>
      </div>
    </CardHeader>
    <CardContent class="flex-1 min-h-0 overflow-y-auto">
      <EmptyState
        v-if="noActionExist"
        title="No action yet..." />
      <ActionEditForm
        v-else
        :key="currentAction.token" />
    </CardContent>
  </Card>
</template>
